import React from "react";
// import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import classes from "./DropDown.module.css";

const Dropdown = ({ data }) => {
  return (
    <div className={classes["dropdown-container"]}>
      {data.map((data, index) => {
        const { name, path } = data;
        return (
          <Link to={path} key={index}>
            {name}
          </Link>
        );
      })}
    </div>
  );
};

export default Dropdown;
